import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	urgentHeading: {
		id: 'loss-aversion.loss-aversion-modal.storage.urgent-heading',
		defaultMessage: 'Don’t lose access to extra storage ',
		description: 'The title introducing the user to the reason they are seeing the modal',
	},
	nonUrgentHeading: {
		id: 'loss-aversion.loss-aversion-modal.storage.non-urgent-heading',
		defaultMessage: 'Keep using 250 GB of storage',
		description: 'The title introducing the user to the reason they are seeing the modal',
	},
	adminSubheading: {
		id: 'loss-aversion.loss-aversion-modal.storage.admin-subheading',
		defaultMessage:
			'Your Standard trial ends on {formattedDate}. Add payment to keep uploading files and images.',
		description: 'The subheading asking the admin to add payment',
	},
	nonAdminSubheading: {
		id: 'loss-aversion.loss-aversion-modal.storage.non-admin-subheading',
		defaultMessage:
			'Ask your admin to purchase Jira Standard for your team. Your trial ends on {formattedDate}.',
		description: 'The subheading of the modal asking the user to ask the admin to add payment',
	},
	addPayment: {
		id: 'loss-aversion.loss-aversion-modal.storage.add-payment',
		defaultMessage: 'Add payment',
		description: 'The text for the primary action button asking admins to add payment',
	},
	maybeLater: {
		id: 'loss-aversion.loss-aversion-modal.storage.maybe-later',
		defaultMessage: 'Maybe later',
		description: 'The text for the secondary action button that closed the modal',
	},
	close: {
		id: 'loss-aversion.loss-aversion-modal.storage.close',
		defaultMessage: 'Close',
		description: 'The text for the button for non-admins that closes the modal',
	},
	usedStorageHeading: {
		id: 'loss-aversion.loss-aversion-modal.storage.used-storage-heading',
		defaultMessage: '{storageUsed} out of 250 GB used',
		description: 'The title for the storage limits section',
	},
	usedStorageSubheading: {
		id: 'loss-aversion.loss-aversion-modal.storage.used-storage-subheading',
		defaultMessage: 'Your team is over the Free plan’s limit of 2 GB',
		description: 'The subheading for the storage limits section',
	},
});
